import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { api } from '../../store/slices/apiSlice';

export default function InactiveDialog() {
  const { userRoles } = api.endpoints.getMe.useQueryState(undefined, {
    selectFromResult: ({ currentData }) => ({
      userRoles: currentData?.user_roles,
    }),
  });

  return (
    <Dialog open={!userRoles || userRoles.length === 0}>
      <DialogTitle>Your account has been deactivated</DialogTitle>
      <DialogContent>
        You are not currently a member of any active Hopthru agency. If you
        believe you are seeing this message in error, please contact your
        account manager.
      </DialogContent>
    </Dialog>
  );
}
